import React, { forwardRef } from "react";
import { ActivityIndicator } from "react-native";
import { styleConstants as C } from "~/style/styleConstants";
import type { ActivityIndicatorProps } from "react-native";

const Spinner = forwardRef<ActivityIndicator, ActivityIndicatorProps>(
  function Spinner(
    {
      size = "large",
      color = C.colorBackgroundTheme,

      ...props
    }: ActivityIndicatorProps,
    ref,
  ) {
    return <ActivityIndicator ref={ref} size={size} color={color} {...props} />;
  },
);

export { Spinner };
